import getHistoryQuiebras from './getHistoryQuiebras'
import getUbosQuiebras from './getUbosQuiebras'

export const getHistoryQuiebrasPromise = getHistoryQuiebras
export const getUbosQuiebrasPromise = getUbosQuiebras
